import classes from "./commissionInfo.module.css"

const CommissionInfo = (props) => {
  const { influencerData } = props

  return (
    <div className={classes.root}>
      <div className={classes.boxContainer}>
        <div className={classes.boxItem}>
          <p className={classes.boxTitle}>Total Commission</p>
          <p className={classes.amount}>${influencerData?.total_commission}</p>
        </div>
        <div className={classes.boxItem}>
          <p className={classes.boxTitle}>Received Commission</p>
          <p className={classes.amount}>
            ${influencerData?.received_commission}
          </p>
        </div>
        <div className={classes.boxItem}>
          <p className={classes.boxTitle}>Unreceived Commission</p>
          <p className={classes.amount}>
            ${influencerData?.unreceived_commission}
          </p>
        </div>
        <div className={classes.boxItem}>
          <p className={classes.boxTitle}>Link Clicks</p>
          <p className={classes.amount}>{influencerData?.link_clicks}</p>
        </div>
        <div className={classes.boxItem}>
          <p className={classes.boxTitle}>Promoted Orders</p>
          <p className={classes.amount}>{influencerData?.promoted_order}</p>
        </div>
      </div>
    </div>
  )
}

export default CommissionInfo
